import { IModule } from './imodule';

export interface IProcessState {
  selectedProcess: IModule;
  allProcesses: IModule[];
  error?: string;
}
